import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";
import { Number } from "components/Form/components/Number/Number";

export const NumberFormComponent = ({ input, meta, fieldProps, fieldAttr }: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <Number
                name={input.name}
                attributes={fieldAttr}
                inputProps={{
                    ...input,
                    isReadOnly: fieldProps.isReadOnly,
                    onBlur: fieldProps?.onBlur ?? input.onBlur,
                }}
            />
        </Input>
    );
};
